import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import BrowserFrame from "./BrowserFrame";

const CheckIcon = () => (
  <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

// SEZIONE 1 — Hero
export default function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="container">
        <div className="hero-content">
          <Reveal as="div" className="hero-badge">
            <span className="dot" />
            Gratis per 30 giorni
          </Reveal>

          <Reveal as="h1" delay={60}>
            Il co-pilota fiscale per la tua{" "}
            <span className="accent">P.IVA forfettaria</span>
          </Reveal>

          <Reveal as="p" className="hero-sub" delay={120}>
            Forfy calcola le tue tasse in tempo reale, ti avvisa prima di
            sforare la soglia e ti aiuta con fatture, F24 e simulazioni. E se
            hai domande, c'è Olli.
          </Reveal>

          <Reveal className="hero-actions" delay={180}>
            <Link to="/richiedi-accesso" className="btn btn-cta">
              Richiedi accesso
            </Link>
            <a href="#olli" className="btn btn-secondary">
              Scopri come funziona
            </a>
          </Reveal>

          <Reveal className="hero-trust" delay={240}>
            <span>
              <CheckIcon />
              Beta privata
            </span>
            <span>
              <CheckIcon />
              Posti limitati
            </span>
          </Reveal>
        </div>

        <Reveal className="hero-visual" delay={200}>
          <div className="hero-visual-inner">
            <BrowserFrame
              src="/landing-assets/screenshots/dashboard.png"
              alt="Dashboard Forfy — fatturato, netto disponibile, soglia forfettario e fatture da incassare"
              className="browser-frame--hero"
            />

            <div className="hero-kpi-badge hero-kpi-badge--netto" aria-hidden="true">
              <span className="hero-kpi-badge-label">Netto calcolato</span>
              <span className="hero-kpi-badge-value">in tempo reale</span>
            </div>

            <div className="hero-kpi-badge hero-kpi-badge--soglia" aria-hidden="true">
              <span className="hero-kpi-badge-value">85k €</span>
              <span className="hero-kpi-badge-label">soglia monitorata</span>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="hero-social-proof">
        <div className="container">
          <div className="hero-social-proof-inner">
            <span className="hero-social-proof-avatars" aria-hidden="true">
              <span className="hero-social-proof-avatar" />
              <span className="hero-social-proof-avatar" />
              <span className="hero-social-proof-avatar" />
              <span className="hero-social-proof-avatar" />
            </span>
            <span className="hero-social-proof-text">
              50+ professionisti in beta
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
